import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Grid } from "../core/components/grid.js";
import { General } from "../../siteManagement/general.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { MachineAppProps } from "./machine.js";
import React from "react"
export default class Allocations extends React.Component<MachineAppAllocationsProps, any>{
    private _gridData = [];
    private _translations = {};
    private _dataUrl: string;

    constructor(props: MachineAppAllocationsProps) {
        super(props)
        this._dataUrl = "Machine/InitAssignmentsView?id=" + encodeURIComponent(props.entity.MaschNr);
        this._translations = props.translations;
    }


    private _getGridData() {
        HTTPService.get(this._dataUrl)
            .then(result => {
                this._gridData = result.Data.Zuordnungen;
                this.setState({});
            });
    }

    private _addAllocation(allocationId) {
        HTTPService.post('Machine/AddAssignment', { maschNr: this.props.entity.MaschNr, assignment: allocationId })
            .then((result) => {
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                    this._getGridData();
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _add = () => {
        const url = "DynamicSearch/Window/Machine/?fullObject=true";

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.setTitle(this._translations["Maschine.Maschinensuche"]);
        sheet.bind(SheetEventType.RowClicked, (dataItem) => {
            HTTPService.post<JsonResultClass>('Machine/TestAssignment', { assignment: dataItem.maschnr })
                .then(result => {
                    if (result.Code === 0) {
                        if (result.Data === true) {
                            DialogHelper.confirm(this._translations["Maschine.BereitsZugewiesen"]).then(isOK => {
                                if (isOK) {
                                    this._addAllocation(dataItem.maschnr);
                                }
                            });
                        } else {
                            this._addAllocation(dataItem.maschnr);
                        }
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        });
    }

    private _edit = (dataItem: any) => {
        const url = 'Machine/Edit?isWindow=true&id=' + encodeURIComponent(dataItem.MaschNr);

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.setTitle(this._translations["WebSMS.Title.MachineEditing"]);
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this._getGridData();
        });
    }

    private _remove = (dataItem) => {
        DialogHelper.confirm(this._translations["Standard.Msg.Loeschen"]).then(isOK => {
            if (isOK) {
                HTTPService.post<JsonResultClass>('Machine/DeleteAssignment', { assignment: dataItem.MaschNr })
                    .then((result) => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            this._getGridData();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this._add();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this._edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._remove(dataItem);
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this._translations["Standard.Neu"], enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this._translations["Standard.Editieren"], enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this._translations["Standard.Loeschen"], enabled: this.props.entity.RecordRight.CanWrite });

        const content = <Grid data={this._gridData} options={this.props.context.allocationsGrid} id="machineAllocations"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} copyCellValue={true}/>

        return (content);
    }
}

interface MachineAppAllocationsProps extends MachineAppProps {
    translations: Array<string>;
}